//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      carouselResponsive: {
        0: {
          items: 1,
          nav: false,
          dots: true,
          margin: 30
        },
        600: {
          items: 1,
          nav: false,
          dots: true
        }
      }
    }
  },
  computed: {
    testimonials () {
      return this.$t('general.testimonials')
    },
    testimonialsGroup () {
      return this.isDesktop() ? this.createGroups(this.testimonials, 2) : this.createGroups(this.testimonials, 5)
    }
  },
  methods: {
    getBackground (i) {
      return this.getStaticsObject(`/testimonial/testimonials_bg_${i}.webp`)
    },
    createGroups (mainList, numGroups) {
      const elementsPerGroup = Math.ceil(mainList.length / numGroups)
      return new Array(numGroups)
        .fill('')
        .map((el, index) => mainList.slice(index * elementsPerGroup, (index + 1) * elementsPerGroup))
    },
    slideChanged (slide) {
      this.currentSlide = slide
    }
  }
}
